import { AbstractControl, FormArray, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms'

import { CustomValidatorFn, ErrorTranslations, FieldMap, TranslatedErrors, ValidatorExtensionFn } from './'
import { hasProps } from '../helpers/object'

export function makeValidatorFn(validator: CustomValidatorFn, extension?: ValidatorExtensionFn): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        let value = control.value

        let result = validator(value)

        if(extension)
            result = {
                ...result,
                ...extension(value)
            }

        if(hasProps(result))
            return result
        return null
    }
}

function humanizeControls(controls: {name: string | number, translatedName: string, control: AbstractControl }[], translations: ErrorTranslations): TranslatedErrors {
    return controls.reduce(
        (result, combined) => {
            combined.control.markAsTouched()

            if(!hasProps(combined.control.errors))
                return result

            let errors = Object.keys(combined.control.errors)

            return {
                ...result,
                [combined.name]: errors.map(err => ({ 
                    translationCode: translations[err],
                    params: {
                        ...combined.control.errors[err].params,
                        field: combined.translatedName,
                    }
                }))
            }
        },
        <TranslatedErrors>{}
    )
}

export function humanizeValidationErrors(control: AbstractControl, translations: ErrorTranslations, fieldMap: FieldMap): TranslatedErrors {
    if(control instanceof FormGroup) {
        let group = control as FormGroup
        let controls = Object.keys(group.controls)

        return humanizeControls(
            controls.map(name => ({ name, translatedName: fieldMap[name], control: group.controls[name] })),
            translations
        )
    }

    if(control instanceof FormArray) {
        let array = control as FormArray

        return humanizeControls(
            array.controls.map((control, name) => ({name, translatedName: '', control})),
            translations
        )
    }

    return humanizeControls(
        [{ name: 'control', translatedName: '', control }],
        translations
    )
}
